import useViewport from '../../../../../common/hooks/useViewport'
import { Panel } from '../../../../../common/panel'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { BIReport } from './BIReport'
import { BusinessConcierge } from './BusinessConcierge'
import { FactSheet } from './FactSheet'
import { GotoDownloadedFiles } from './GotoDownloadedFiles'
import { InternationalReport } from './InternationalReport'
import { Screening } from './Screening'
import classes from './index.module.scss'

export const ORDER_DETAILS_ID = 'ORDER_DETAILS_ID'

export const OrderDetails = () => {
  const { height } = useViewport()

  return (
    <Panel
      label="userManagement.orderManagement.orderDetail.ORDER_DETAILS"
      renderRightHeader={() => <GotoDownloadedFiles />}
      isI18n
    >
      <div className={classes.container}>
        <ScrollComponent
          id={ORDER_DETAILS_ID}
          autoHeight
          autoHeightMax={height * 0.4}
        >
          <FactSheet />
          <BIReport />
          <Screening />
          <InternationalReport />
          <BusinessConcierge />
        </ScrollComponent>
      </div>
    </Panel>
  )
}
